const styles = (theme) => ({
  root: {
    overflow: 'hidden',
    width: '100%',
    position: 'absolute',
    height: '100%',
  },
  withMinimizeVoiceCall: {
    overflow: 'hidden',
    width: '100%',
    position: 'absolute',
    height: 'calc(100% - 60px)',
  },
  padding: {
    // Height of bottom nav
    paddingBottom: theme?.mixins?.toolbar?.minHeight,
  },
});

export default styles;
